import Bloc from './Bloc.js';
import Types from './Types.js';

export default class EndTurn extends Bloc {

	constructor (src, ctx) {

		super("endturn", src, ctx, true);
		this.f = (src, ins) => {
			if (!src.autocast) {
				//src.master.endPlayerTurn();
				src.master.hand.cards.forEach(c => c.addProperty("locked"));
				src.master.player.lockSkill();
			}
			return [];
		};
		this.types = [];
	}
}